<template>
    <div class="common-data">{{ text }}</div>
</template>

<script>
import response from './response';
export default {
    name: 'common-data',
    props: {
        name: String
    },
    data: () => ({
        text: ''
    }),
    created () {
        response.onload(res => {
            let target = res.find(v => v.keyname == this.name)
            this.text = target.value
        })
    },
    destroyed () {

    }
}
</script>

<style scoped>
.common-data {
    display: contents;
}
@supports not (display: contents) {
    .common-data {
        display: inline;
    }
}
</style>